export default __webpack_public_path__ + "static/college-audition-guide-preview-4-4ae919cf5e79bab4f0c0425e7e040b76.jpg";